import {POPUP_TEXT} from '@/constant/constants'
import storage from '@/plugins/storage'

export default {
  setCoinChange (state, { type, deltaCoin, deltaValue }) {
    // 法豆或者法力有增值才执行变化
    if (deltaCoin || deltaValue) {
      state.coinChangeData = {
        show: true,
        deltaCoin,
        deltaValue,
        desc: Object.values(POPUP_TEXT).find(item => item.value === type).text,
      }
    }
  },
  setLevelChange (state, { level, levelName, icon, starLevel }) {
    // 判断当前level和新的level是否一致，如果一致，不进行操作，否则更新当前等级以及提示信息
    let profile = storage.get('profile') || {}
    if (level && profile.level && profile.level !== level) {
      profile.level = level
      storage.set('profile', profile)
      state.levelChangeData = {
        show: true,
        level,
        levelName,
        starLevel,
        icon,
      }
    } else {
      storage.set('profile', { level: level })
    }
  },
  setCurrentVideo (state, video) {
    state.currentVideo = video
  },
  setShowPoster (state, isShowPoster) {
    state.showPoster = isShowPoster
  },
  updateCoursePv(state, count) {
    state.coursePv = count
  },
}
